import React, { FC } from "react";
import { InfoProps } from "./InfoProps";
import { parseSize } from "../utils/utils";

const Info: FC<InfoProps> = (props: InfoProps) => {
  const { size, color, colorFill, onClick, className, style } = props;
  const finalSize = parseSize(size);

  const finalStyle = style ? style : {};
  return (
    <svg
      className={className || ""}
      style={onClick ? { cursor: "pointer", ...finalStyle } : finalStyle}
      xmlns="http://www.w3.org/2000/svg"
      height={`${finalSize}px`}
      viewBox="0 0 24 24"
      width={`${finalSize}px`}
      fill={color || "#000000"}
      onClick={() => onClick?.()}
    >
      <path d="M0 0h24v24H0V0z" fill={ "none"} />
      <path
        d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm1 13h-2v-6h2v6zm0-8h-2V7h2v2z"
        fill={colorFill ||"none"}
        //opacity=".7"
      />
      <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    </svg>
  );
};
export default Info;
